import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

type tFunc = ReturnType<typeof useTranslation>['t'];

export const firstNameValidationSchema = (t: tFunc) =>
  Yup.string()
    .required(t('account.validation.firstNameRequired'))
    .matches(/^(?!\s)(?!.*\s$).+$/, t('account.validation.firstNameStartOrEndWithSpaces'))
    .matches(/^[^0-9]+$/, t('account.validation.firstNameContainNumbers'))
    .matches(/^[a-zA-ZÀ-ÖØ-öø-ÿ'’\-. ]+$/, t('account.validation.firstNameContainSpecialCharacters'))
    .min(2, ({ min }) => t('account.validation.tooShortFirstName', { min }))
    .max(50, ({ max }) => t('account.validation.tooLongFirstName', { max }));

export const lastNameValidationSchema = (t: tFunc) =>
  Yup.string()
    .required(t('account.validation.lastNameRequired'))
    .matches(/^(?!\s)(?!.*\s$).+$/, t('account.validation.lastNameStartOrEndWithSpaces'))
    .matches(/^[^0-9]+$/, t('account.validation.lastNameContainNumbers'))
    .matches(/^[a-zA-ZÀ-ÖØ-öø-ÿ'’\-. ]+$/, t('account.validation.lastNameContainSpecialCharacters'))
    .min(2, ({ min }) => t('account.validation.tooShortLastName', { min }))
    .max(50, ({ max }) => t('account.validation.tooLongLastName', { max }));

export const passwordValidationSchema = (t: tFunc) =>
  Yup.string()
    .required(t('account.validation.passwordRequired'))
    .matches(/\w*[a-z]\w*/, t('account.validation.invalidPasswordSmallLetter'))
    .matches(/\w*[A-Z]\w*/, t('account.validation.invalidPasswordCapitalLetter'))
    .matches(/\d/, t('account.validation.invalidPasswordNumber'))
    .matches(/[!@#$%^&*()\-_"=+{}; :,<.>]/, t('account.validation.invalidPasswordSpecial'))
    .min(6, ({ min }) => t('account.validation.passwordLength', { min }));
